import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { CookieService } from 'ngx-cookie-service';
import { Subject, throwError } from 'rxjs';
import { catchError, filter, finalize, takeUntil } from 'rxjs/operators';
import { isNullOrUndefined } from '../app/core/utils';
import { ActiveDirectoryService } from './core/active-directory.service';
import { AuthApi } from './core/api.gen';
import { AuthService } from './core/auth.service';
import { CommonService } from './core/common.service';
import { LoaderService } from './core/loader.service';
import { TimeOutService } from './core/time-out.service';
import { Logger } from './utils/Logger';

@Component({
	selector: "eos-root",
	templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  isDev = false;
  isAuthenticated: boolean;
  isIframe = false;
  loginDisplay = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,	private cookieService: CookieService,
		private timeOut: TimeOutService,
    private loader: LoaderService,private router: Router,private authApi: AuthApi,private adService: ActiveDirectoryService,
		private commonService: CommonService,private activatedRoute: ActivatedRoute,
  ) {
    this.isDev = window.location.href.includes('localhost');
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
console.log('Inside AppComponent ngOnInit');
    this.msalService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    // this.msalBroadcastService.msalSubject$
    //   .pipe(
    //     filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
    //   )
    //   .subscribe((result: EventMessage) => {
    //     console.log('Inside AppComponent ngOnInit2');
    //     if (this.msalService.instance.getAllAccounts().length === 0) {
    //       window.location.pathname = "/";
    //     } else {
    //       this.setLoginDisplay();
    //     }
    //   });
   // console.log('Inside AppComponent ngOnInit3');
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        console.log('Inside AppComponent ngOnInit4');
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        this.timeOut.initActivity();
      })
  }

  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    console.log('Login Display:', this.loginDisplay);
  }

checkAndSetActiveAccount() {
    let activeAccount = this.msalService.instance.getActiveAccount();
    console.log('Inside checkAndSetActiveAccount')
    if (activeAccount && !this.authService.isAuthenticated) {
      this.loadAppUser();
    }
    else {
      if (
        !activeAccount &&
        this.msalService.instance.getAllAccounts().length > 0
      ) {
        console.log('Inside checkAndSetActiveAccount else')
        let accounts = this.msalService.instance.getAllAccounts();
        this.msalService.instance.setActiveAccount(accounts[0]);

        this.loadAppUser();
      } else {
        this.tryLogin();
      }
    }
  }
  
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
   tryLogin() {
    console.log('Inside tryLogin')
    if (this.msalService.instance.getAllAccounts().length <= 0) {
      this.loginUser();
    }
  }

  loginUser() {
    const isIE = true; // window.navigator.userAgent.indexOf('MSIE') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

    if (isIE) {
      this.msalService.loginRedirect();
    } else {
      this.msalService.loginPopup();
    }
  }

  loadAppUser() {
    this.loader.show();
    let activeAccount = this.msalService.instance.getActiveAccount();
    let displayName = "";
    console.log('Inside loadAppUser')
    if(!isNullOrUndefined(activeAccount?.name) && activeAccount?.name.trim() != ""){
      displayName =  activeAccount.name;
    } 
    else{
      displayName =  activeAccount.username;
    } 
    this.authApi.getAppUser(displayName).pipe(
          finalize(() => {
            this.loader.clear();
          }),
          catchError(err => {
            localStorage.clear();
            this.router.navigate(['/denied']);
            return throwError(err);
          })
        ).subscribe((appUser) => {
          this.timeOut.updatelatestUserActivity();
          this.authService.setAppUser(appUser);
          this.commonService.delegateStatus$.next(appUser.delegateId > 0);
          this.authApi.getAntiforgeryToken().subscribe(resp => {
            this.cookieService.set("XSRF-TOKEN", resp, {secure:true, sameSite:"None"});
            this.adService.me().subscribe();
            let returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];

            if (isNullOrUndefined(returnUrl)) {
              if (localStorage.getItem('returnUrl')) {
                returnUrl = localStorage.getItem('returnUrl');
              } else {
                returnUrl = '/home';
              }
            } else if ((returnUrl + '').length === 0) {
              returnUrl = localStorage.getItem('returnUrl');
            } else {
              returnUrl = '/home';
            }
            this.router.navigate([returnUrl]);
          });
        });
	}
}
